import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React, { FC } from 'react';
import * as style from './index.module.scss';

const Header: FC = () => (
    <header className={style.header}>
        <Link to="/">
            <StaticImage
                className={style.logo}
                src="../../images/blog.png"
                alt="blog logo"
                loading="eager"
            />
        </Link>
    </header>
);
export default Header;
